import { render, staticRenderFns } from "./ResultTitle.vue?vue&type=template&id=22f8a3dc&scoped=true&"
import script from "./ResultTitle.vue?vue&type=script&lang=js&"
export * from "./ResultTitle.vue?vue&type=script&lang=js&"
import style0 from "./ResultTitle.vue?vue&type=style&index=0&id=22f8a3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f8a3dc",
  null
  
)

export default component.exports